/**
 * @author Hideo Yamada
 * @description https://marvelapp.com/4gh2ba1/screen/47387792
 */

import React from 'react';
import PropTypes from 'prop-types';
import Image from 'react-bootstrap/Image';

const Team = ({ className, type = 'presidents', title, size = 'medium', link }) => (
    <div className={`team ${size} ${className} cursor-pointer`} style={{ backgroundImage: `url(/images/landing/events_${type}_bg.png)` }} onClick={() => !!link && window.open(link, '_self')}>
        <Image className="team-logo" src={`/images/landing/events_${type}_logo.png`} />
        {!!title && <p className="dsl-w18 bold team-title">{title}</p>}
    </div>
);

Team.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.oneOf(['presidents', 'dses', 'leadership', 'webinar']),
    size: PropTypes.oneOf(['large', 'medium', 'small']),
    link: PropTypes.string,
};

export default Team;
